<template>
  <div class="registerPage">
    <div class="background"></div>
    <div class="registerBox">
      <div class="logoSection">
        <img class="logo" src="@/assets/phoenixEng.png" alt="Phoenix Engineering">
        <p class="logoText">TRANSPARENT IN DESIGN AND CONSTRUCTION</p>
        <router-link class="link" :to="{ name: 'login' }">{{ t("link") }}</router-link>
      </div>
      <form @submit.prevent="register" class="formRegister">
        <h3>{{ t("signUp") }}</h3>
        <div class="inpunWrap" id="inpFirst">
          <BaseInput class="baseInput" v-model="userName" :placeholder="t('userName')"/>
          <p class="validate" v-if="v$.userName.$error">{{ v$.userName.$errors[0].$message }}</p>
        </div>

        <div class="inpunWrap">
          <BaseInput
            class="baseInput"
            v-model="passWord"
            :placeholder="t('passWord')"
            type="password"
          />
          <p class="validate" v-if="v$.passWord.$error">{{ v$.passWord.$errors[0].$message }}</p>
        </div>

        <div class="inpunWrap">
          <BaseInput
            class="baseInput"
            v-model="confirmPassWord"
            :placeholder="t('confirmPassWord')"
            type="password"
          />
          <p
            class="validate"
            v-if="v$.confirmPassWord.$error"
          >{{ v$.confirmPassWord.$errors[0].$message }}</p>
        </div>

        <div class="inpunWrap">
          <BaseInput class="baseInput" v-model="name" :placeholder="t('name')"/>
          <p class="validate" v-if="v$.name.$error">{{ v$.name.$errors[0].$message }}</p>
        </div>

        <div class="inpunWrap" id="inpLast">
          <BaseInput class="baseInput" v-model="studentNumber" :placeholder="t('studentNumber')"/>
          <p
            class="validate"
            v-if="v$.studentNumber.$error"
          >{{ v$.studentNumber.$errors[0].$message }}</p>
        </div>

        <p
          class="serverError"
          v-if="error == 'Request failed with status code 400'"
        >{{ t("error") }}</p>

        <button class="btn" type="submit">{{ t("signUp") }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  sameAs,
  integer,
  helpers
} from "@vuelidate/validators";
import BaseInput from "@/components/BaseInput";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  components: {
    BaseInput
  },
  data() {
    return {
      v$: useValidate(),
      name: "",
      userName: "",
      passWord: "",
      confirmPassWord: "",
      studentNumber: ""
    };
  },

  validations() {
    return {
      userName: {
        required: helpers.withMessage(this.t("validations.required"), required),
        minLength: helpers.withMessage(
          this.t("validations.minLengthUN"),
          minLength(6)
        )
      },
      passWord: {
        required: helpers.withMessage(this.t("validations.required"), required),
        minLength: helpers.withMessage(
          this.t("validations.minLengthPW"),
          minLength(6)
        )
      },
      confirmPassWord: {
        required: helpers.withMessage(this.t("validations.required"), required),
        sameAs: helpers.withMessage(
          this.t("validations.sameAs"),
          sameAs(this.passWord)
        )
      },

      name: {
        required: helpers.withMessage(this.t("validations.required"), required)
      },

      studentNumber: {
        integer: helpers.withMessage(this.t("validations.integer"), integer),
        required: helpers.withMessage(this.t("validations.required"), required),
        minLength: helpers.withMessage(
          this.t("validations.studentNr"),
          minLength(5)
        ),
        maxLength: helpers.withMessage(
          this.t("validations.studentNr"),
          maxLength(5)
        )
      }
    };
  },

  methods: {
    register() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.$store
          .dispatch("registerUser", {
            name: this.name,
            userName: this.userName,
            passWord: this.passWord,
            studentNumber: this.studentNumber
          })
          .then(() => {
            if (!this.error) {
              this.$router.push({ name: "login" });
            }
          });
      }
    }
  },
  created() {
    this.$store.dispatch("logOut");
  },
  computed: {
    error() {
      return this.$store.state.errorRegister;
    }
  }
};
</script>

<i18n>
{
  "en-GB": {
    "name": "Full name",
    "userName": "Username",
    "passWord": "Password",
    "confirmPassWord":"Confirm password",
    "studentNumber": "Student number",
    "link":"Already have and account? Sign in here.",
    "error":"User already exists",
    "signUp":"Sign up",

    "validations": {
      "required":"This field is required!",
      "sameAs":"Passwords don't match!",

      "minLengthPW":"Password must be at least 6 characters long!",
      "minLengthUN":"Username must be at least 6 characters long!",

      "studentNr":"Student number should be 5 digits long!",

      "integer":"Please fill with digits!",
      "letter":"Please fill with letters!"
    }
  },

    "nl-NL": {
    "name": "Naam en achternaam",
    "userName": "Gebruikersnaam",
    "passWord": "Wachtwoord",
    "confirmPassWord":"Bevestig wachtwoord",
    "studentNumber": "Studenten nummer",
    "link":"Heb je al een account? Meld je hier aan.",
    "error":"Gebruiker bestaat al.",
    "signUp":"Inschrijven",

    "validations": {
      "required":"Dit veld is verplicht",
      "sameAs":"De wachtwoorden komen niet overeen!",

      "minLengthPW":"Het wachtwoord moet op zijn minst 6 karakters lang zijn!",
      "minLengthUN":"De gebruikersnaam moet op zijn minst 6 karakters lang zijn!",

      "studentNr":"Het studentenummer moet 5 getallen lang zijn!",

      "integer":"Vul alstublieft in met getallen!",
      "letter":"Vul alstublieft in met letters!"
    }
  }
}
</i18n>


<style scoped>
.registerPage {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
}
.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}

.registerBox {
  display: flex;
  position: relative;
  margin: auto;

  height: 650px;
  width: 1000px;

  background-color: rgba(221, 221, 221, 0.92);
  box-shadow: 0 32px 64px rgba(235, 235, 235, 0.267);
}

.logoSection {
  position: relative;
  background-color: rgb(62, 62, 62);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;
}
.logo {
  width: 350px;
}

.logoText {
  width: 300px;
  margin: 0px;
}

.formRegister {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 60%;
  align-items: center;
  justify-content: space-between;
}

h3 {
  font-size: 32px;
  margin-top: 60px;
  margin-bottom: 0px;
}

.inpunWrap {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.link {
  position: absolute;
  bottom: 0;
  margin-bottom: 30px;
  font-size: 15px;
  text-decoration: none;
  color: gray;
}

.link:hover {
  transform: scale(1.05);
}

.baseInput {
  display: inline-flex;
  margin-top: 5px;
}

#inpFirst {
  margin-top: 30px;
}
#inpLast {
  margin-bottom: 50px;
}

.validate {
  width: 200px;
}

p {
  font-weight: 600;
  color: rgb(216, 23, 23);
  font-size: 14px;
  padding: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

.btn {
  font-family: "Raleway", sans-serif;
  letter-spacing: 1px;
  padding: 12px 30px;
  background-color: rgb(62, 62, 62);
  margin-bottom: 90px;

  border-style: none;
  color: rgb(255, 255, 255);

  font-size: 15px;
  cursor: pointer;

  box-shadow: 0 0px 3px 0px rgb(89, 102, 100);
}
.btn:hover {
  transform: scale(1.05);
}

.serverError {
  position: absolute;
  bottom: 0;
  margin-bottom: 45px;
}

@media screen and (max-width: 1200px) {
  .registerBox {
    height: 550px;
    width: 800px;
  }

  .logo {
    width: 280px;
  }

  .logoText {
    width: 280px;
  }

  h3 {
    font-size: 28px;
    margin-top: 50px;
  }

  .link {
    font-size: 13px;
  }
  .baseInput {
    margin-top: 5px;
  }

  #inpFirst {
    margin-top: 20px;
  }
  #inpLast {
    margin-bottom: 30px;
  }

  .btn {
    margin-bottom: 60px;
    padding: 10px 20px;
    font-size: 13px;
  }
  p {
    font-size: 13px;
  }
  .validate {
    width: 180px;
  }
  .serverError {
    margin-bottom: 25px;
    font-size: 13px;
  }
}

@media screen and (max-width: 1000px) {
  .registerBox {
    height: 500px;
    width: 700px;
  }

  .logo {
    width: 230px;
  }

  .logoText {
    width: 230px;
  }

  h3 {
    font-size: 22px;
    margin-top: 40px;
  }

  .link {
    font-size: 11px;
  }
  .baseInput {
    margin-top: 5px;
  }

  #inpFirst {
    margin-top: 20px;
  }
  #inpLast {
    margin-bottom: 30px;
  }

  .btn {
    font-size: 11px;
    margin-bottom: 60px;
  }
  p {
    font-size: 11px;
  }
  .validate {
    font-size: 11px;
    width: 150px;
  }
  .serverError {
    margin-bottom: 25px;
    font-size: 11px;
  }
}

@media screen and (max-width: 750px) {
  .registerBox {
    height: 700px;
    width: 400px;

    flex-direction: column;
    align-content: center;
  }

  .logoSection {
    width: 100%;
    height: 200px;
    background-color: initial;
    order: 2;
  }

  .formRegister {
    margin-top: 0px;
    width: 100%;
    height: 70%;
  }

  h3 {
    font-size: 22px;
    margin-top: 50px;
  }

  .baseInput {
    margin-top: 5px;
  }

  #inpFirst {
    margin-top: 20px;
  }
  #inpLast {
    margin-bottom: 10px;
  }

  .btn {
    font-size: 11px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  p {
    font-size: 11px;
  }
  .validate {
    font-size: 11px;
    width: 150px;
  }
  .serverError {
    margin-top: 30px;
    margin-bottom: 0px;
    font-size: 11px;
  }
  .link {
    font-size: 11px;
    margin-bottom: 15px;
    color: black;
    font-weight: 600;
    text-decoration: underline;
  }

  @media screen and (max-width: 500px) {
    .registerBox {
      height: 650px;
      width: 400px;
    }
  }

  @media screen and (max-width: 440px) {
    .registerBox {
      height: 650px;
      width: 330px;
    }
  }
}
</style>
